// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"d596adf6","238":"2a2c8334","328":"233de914","434":"111cabb8","593":"59167b70","632":"c1cf85bc","662":"183fe25f","850":"19261321","893":"ce35a1d9"}[chunkId] + ".chunk.js";
};